import React from "react";
import PATH from "constants/path";
import { Route, Switch } from "react-router-dom";
import PageNotFound from "views/PageNotFound";
import Setting from "./pages/Setting";
import Account from "./pages/Account";
import ChangePassword from "./pages/ChangePassword";
import Info from "./pages/Info";
import ChangeLogin from "./pages/ChangeLogin";
import ChangeEmail from "./pages/ChangeEmail";

function MemberSetting() {
  return (
    <Switch>
      <Route exact path={PATH.SETTING} component={Setting} />
      <Route exact path={PATH.MEMBER_INFO} component={Info} />
      <Route exact path={PATH.CHANGE_LOGIN} component={ChangeLogin} />
      <Route exact path={PATH.CHANGE_EMAIL} component={ChangeEmail} />
      <Route exact path={PATH.ACCOUNT_INFO} component={Account} />
      <Route exact path={PATH.PASSWORD} component={ChangePassword} />
      <Route component={PageNotFound} />
    </Switch>
  );
}

export default MemberSetting;
